import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 200 200",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M86.4 153.8c37.2 0 67.4-30.2 67.4-67.4S123.6 19 86.4 19 19 49.2 19 86.4s30.2 67.4 67.4 67.4zm0 9c-42.2 0-76.4-34.2-76.4-76.4S44.2 10 86.4 10s76.4 34.2 76.4 76.4-34.2 76.4-76.4 76.4zm64.2-5.8c-.8-.8-1.3-2-1.3-3.2 0-1.2.5-2.3 1.3-3.1.8-.8 2-1.3 3.1-1.3 1.2 0 2.3.4 3.2 1.3l31.8 31.8c.8.8 1.3 2 1.3 3.2 0 1.2-.5 2.3-1.3 3.1-.8.8-2 1.3-3.1 1.3-1.2 0-2.3-.4-3.2-1.3L150.6 157z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: "tri-icon",
    style: _normalizeStyle(`font-size: ${_ctx.size}; color: ${_ctx.color}; width: 1em; height: 1em; display:block; line-height: 0;`)
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
  ], 4))
}